module.exports = __webpack_public_path__ + "6f744de9526f4ef7546108c4ee0b93de.pdf";